<div class="choices-container">
    <ng-container *ngFor="let choice of component.choices">
        <button class="choice" (click)="playerService.onChoice(choice, step)"
            [ngClass]="contentService.getChoiceClass(component, choice)" [hidden]="playerService.checkChoice(choice)"
            [ngStyle]=" component
                | componentStyle : 'player' : scenario : stringify(component): choice" tabindex="0" type="button"
            (mousedown)="onMouseDown(choice)" (mouseup)="onMouseUp(choice)" (focus)="onFocus(choice)"
            (blur)="onBlur(choice)" (mouseenter)="onMouseEnter(choice)" (mouseleave)="onMouseLeave(choice)">
            <div *ngIf="choice.media && choice.media.url">
                <img src="{{ choice?.media?.url }}" alt="Image for choice `{{ choice.title }}`"
                    style="max-height: 150px" class="rounded-3" />
            </div>
            <i class="bx {{ choice.icon }}" *ngIf="choice.icon" [ngClass]="{ 'me-1': !choice?.config?.hideText }"></i>
            <ng-container *ngIf="!choice?.config?.hideText">{{
                choice.title 
                }}</ng-container>
            <span *ngIf="choice?.config?.hideText" class="visually-hidden">{{ choice.title }}</span>
        </button>
    </ng-container>
</div>